import React, { Suspense, lazy } from "react";
import "./App.css";

import { Routes, Route, useLocation } from "react-router-dom";

import { Toaster } from "./components/ui/toaster";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import { ChargerTypeProvider } from "./contexts/ChargerTypeContext";
import { WalletProvider } from "./contexts/WalletContext";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./components/Home";

// Lazy loaded page components to optimize bundle division and improve Lighthouse score
const EVCalculator = lazy(() => import("./components/EVCalculator"));
const InvestmentTable = lazy(() => import("./components/InvestmentTable"));
const PricingPlans = lazy(() => import("./components/PricingCard"));
const CustomSignup = lazy(() => import("./components/CustomSignUp"));
const Callback = lazy(() => import("./components/Callback"));

const PageLoader = () => (
  <div className="h-screen flex items-center justify-center bg-white">
    <div className="h-10 w-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function AppLayout() {
  const location = useLocation();
  const showHeader = location.pathname !== "/";

  return (
    <>
      {showHeader && <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/calculator" element={
          <Suspense fallback={<PageLoader />}>
            <EVCalculator />
          </Suspense>
        } />
        <Route path="/admin/table" element={
          <Suspense fallback={<PageLoader />}>
            <InvestmentTable />
          </Suspense>
        } />
        <Route path="/Pricing" element={
          <Suspense fallback={<PageLoader />}>
            <PricingPlans />
          </Suspense>
        } />
        <Route path="/signup" element={
          <Suspense fallback={<PageLoader />}>
            <CustomSignup />
          </Suspense>
        } />
        <Route path="/callback" element={
          <Suspense fallback={<PageLoader />}>
            <Callback />
          </Suspense>
        } />
      </Routes>

      <Footer />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <CurrencyProvider>
        <WalletProvider>
          <ChargerTypeProvider>
            <AppLayout />
          </ChargerTypeProvider>
        </WalletProvider>
      </CurrencyProvider>
    </div>
  );
}

export default App;
